import type { FC, ReactNode } from 'react'

import { Check } from 'lucide-react'

import { cn } from '@/lib/utils'
import { getHubTheme } from '@/constants/hubs'

interface KeyTakeawaysProps {
    items: string[]
    hub: string
    className?: string
}

export const KeyTakeaways: FC<KeyTakeawaysProps> = ({ items, hub, className }): ReactNode => {
    if (items.length === 0) return null

    const theme = getHubTheme(hub)

    return (
        <section
            aria-labelledby='key-takeaways-heading'
            className={cn('rounded-xl border p-5 sm:p-6', theme.border, theme.softBg, className)}
        >
            <h2
                id='key-takeaways-heading'
                className={cn('font-heading text-base font-semibold tracking-tight', theme.ink)}
            >
                Key takeaways
            </h2>

            <ul className='mt-4 space-y-2.5'>
                {items.map(item => (
                    <li key={item} className='flex gap-2.5 text-sm leading-relaxed text-foreground/85'>
                        <Check className={cn('mt-0.5 size-4 shrink-0', theme.text)} aria-hidden='true' />
                        <span>{item}</span>
                    </li>
                ))}
            </ul>
        </section>
    )
}
